import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasProgramTemplateVersionSchema = withDefaults({
  type: 'tas-program-template-version',
  traits: ['version'],
  fields: [],
});

export default TasProgramTemplateVersionSchema;
